module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gridlist-demo-container"
  }, [_c('mu-grid-list', {
    staticClass: "gridlist-demo",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "0px",
      "margin-bottom": "0px",
      "margin-right": "0px"
    }
  }, _vm._l((_vm.hotsinger), function(tile, index) {
    return _c('mu-grid-tile', {
      key: index,
      attrs: {
        "titlePosition": "top",
        "titleBarClass": "myclass"
      }
    }, [_c('img', {
      staticClass: "setimg",
      attrs: {
        "src": tile.imgurl
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      slot: "title"
    }, [_vm._v(_vm._s(tile.classname))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "top": "0",
        "left": "0",
        "height": "100%",
        "z-index": "1"
      },
      on: {
        "click": function($event) {
          _vm.singerlist(tile.classid, tile.classname)
        }
      }
    })])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459c457a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZhenV_RT/xtotallist.vue
// module id = 252
// module chunks = 0